import { State } from 'jumpstate'

const defaultFilters = Object.freeze({
  highlighted: 0,
  search: '',
  datatype: '',
  filetype: '',
  status: 'unstable'
})

const SearchState = State({
  initial: {
    isOpen: false,
    filters: {...defaultFilters}
  },
  searchToggle (state, payload) {
    return Object.assign({}, state, {
      isOpen: !state.isOpen
    })
  },
  searchOpen (state, payload = {}) {
    if (state.isOpen) return state
    return Object.assign({}, state, {
      isOpen: true,
      filters: {
        ...defaultFilters,
        ...payload
      }
    })
  },
  searchClose (state, payload) {
    if (!state.isOpen) return state
    return Object.assign({}, state, {
      isOpen: false,
      filters: {
        ...defaultFilters
      }
    })
  }
})

export default SearchState



// WEBPACK FOOTER //
// ./src/components/Search/state.js